// extracted by mini-css-extract-plugin
export default {"cls1":"ContentFeedback-cls1_yAh","cls2":"ContentFeedback-cls2_DUS ContentFeedback-cls1_yAh"};